import { IDictionaryItem } from 'api/types';

export const getCodesArrayFromDictionaryArray = (arr: IDictionaryItem[]) => arr.map((item) => item.code);
export const removeItemsById = (arr: IDictionaryItem[], parentId: number) =>
  arr.filter((item) => item.parentId !== parentId);
export const checkArrayIncludesCode = (arr: IDictionaryItem[], code: number) => arr.some((item) => item.code === code);
